/**
 * App entry point for handwriting recognition: a $P point-cloud recogniser
 * (see ./recognizer and docs/HANDWRITING.md) whose calibration samples are
 * persisted in localStorage under 'dropstack.hw.samples'.
 */
import type { HandwritingRecognizer } from '../contracts.ts';
import { browserStorage, createPersistentRecognizer } from './persistence.ts';

export function createRecognizer(): HandwritingRecognizer {
  return createPersistentRecognizer(browserStorage());
}
